import formatDate from "@/utils/date/format";
import newDateWrapper from "@/utils/date/new-date-wrapper";

const currentDate = newDateWrapper()

export default [
  {
    path: "/targets",
    component: () => import(/* webpackChunkName: "Targets" */ "@/views/targets/Index.vue"),
    name: "targets",
    meta: {
      bypassCacheKeyCheck: true,
      requireAuth: true,
    },
    children: [
      {
        path: "campaigns",
        component: () => import(/* webpackChunkName: "CampaignsTargets" */"@/views/targets/campaigns/Index.vue"),
        meta: {
          bypassCacheKeyCheck: true,
          requireAuth: true,
        },
        children: [
          {
            path: "",
            name: "campaigns-targets",
            component: () => import(/* webpackChunkName: "CampaignsTargetsList" */"@/views/targets/campaigns/List.vue"),
            meta: {
              title: "campaignsTargets",
              filtersScheme: {
                month: formatDate({
                  date: newDateWrapper([currentDate.getFullYear(), currentDate.getMonth(), 1]),
                  options: {
                    year: "numeric",
                    month: "2-digit",
                  },
                  locale: "fr-CA",
                }),
                campaigns: [],
                buId: "",
                cgds: [],
                cgms: [],
                sortMetrics: "",
                sortDirection: "asc",
              },
            },
          },

          {
            path: "set-targets",
            component: () => import(/* webpackChunkName: "setCampaignsTargetsForm" */"@/views/targets/campaigns/Create.vue"),
            name: "set-campaigns-targets",
            meta: {
              bypassCacheKeyCheck: true,
              title: "setCampaignsTargets",
            },
          },
        ],
      },
      {
        path: "partners",
        component: () => import(/* webpackChunkName: "PartnersTargets" */"@/views/targets/partners/Index.vue"),
        meta: {
          bypassCacheKeyCheck: true,
          requireAuth: true,
          title: "partners",
        },
        children: [
          {
            path: "",
            name: "partners-targets",
            component: () => import(/* webpackChunkName: "PartnersTargetsList" */"@/views/targets/partners/List.vue"),
            meta: {
              title: "partnersTargets",
              filtersScheme: {
                month: formatDate({
                  date: newDateWrapper([currentDate.getFullYear(), currentDate.getMonth(), 1]),
                  options: {
                    year: "numeric",
                    month: "2-digit",
                  },
                  locale: "fr-CA",
                }),
                buId: "",
                partners: [],
                sortMetrics: "",
                sortDirection: "asc",
              },
            },
          },
          {
            path: "set-targets",
            component: () => import(/* webpackChunkName: "PartnersTargetsForm" */"@/views/targets/partners/Create.vue"),
            name: "set-partners-targets",
            meta: {
              bypassCacheKeyCheck: true,
              title: "setPartnersTargets",
            },
          },
        ],
      },
      {
        path: "cg-team",
        component: () => import(/* webpackChunkName: "CGTeamTargets" */"@/views/targets/cg-team/Index.vue"),
        meta: {
          bypassCacheKeyCheck: true,
          requireAuth: true,
        },
        children: [
          {
            path: "",
            name: "cg-team-targets",
            component: () => import(/* webpackChunkName: "CGTeamTargetsList" */"@/views/targets/cg-team/List.vue"),
            meta: {
              title: "cgTeamTargets",
              entityName: "cg-team-targets",
              hasFilters: true,
              filtersScheme: {
                month: formatDate({
                  date: newDateWrapper([currentDate.getFullYear(), currentDate.getMonth(), 1]),
                  options: {
                    year: "numeric",
                    month: "2-digit",
                  },
                  locale: "fr-CA",
                }),
                campaigns: [],
                buId: "",
                cgds: [],
                cgms: [],
              },
            },
          },
        ],
      },
    ],
  },
]
